/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { Route, RouteComponentProps, withRouter } from 'react-router-dom';
import { stringify } from '@tock/query-string';

import { StoreType } from '@tock/shared/utils/connect';

interface Props extends RouteComponentProps {
  app: StoreType['app'];
  component?: any;
  exact?: boolean;
  render?(props: any): React.ReactFragment;
  path?: string;
  redirectTo?: string;
  message?: string;
}

class ProtectedRoute extends React.Component<Props> {
  static defaultProps: Partial<Props> = {
    redirectTo: '/login',
  };

  componentDidMount() {
    const { app, history, location, redirectTo, message } = this.props;
    const isAuthenticated = !!app.jwtToken;

    if (!isAuthenticated) {
      history.replace({
        pathname: redirectTo,
        search: stringify({
          continue: location.pathname === '/logout' ? '/' : location.pathname + location.search,
          message,
        }),
      });
    }
  }

  render() {
    const isAuthenticated = !!this.props.app.jwtToken;
    if (!isAuthenticated) {
      return null;
    }

    return <Route {...this.props} />;
  }
}

export default withRouter(ProtectedRoute);
